module.exports = __webpack_public_path__ + "img/6.91295655.jpg";